<template>
    <footer>
        <div class="footer-main dark-bg section-padding" :class="FooterStyle" id="footer">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="footer-content text-center">
                             <ul class="footer-social-link">
                                <li v-for="(social, socials) in socials" :key="socials">
                                    <a :href="social.url" :target="social.target">
                                        <i :class=social.icon></i>
                                    </a>
                                </li>
                            </ul>
                            <h3 class="footer-title">RHINOCAM.ORG</h3>
                            <p><b>For more information contact:</b></p><a href="mailto:careforwild@africam.com">careforwild@africam.com</a></br>
                            <p>© Copyright 2021 Rhinocam.org | All rights reserved</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-bottom black-bg" :class="FooterStyle">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 order-2 order-md-1">
                        <div class="copyright">
                      
                        </div>
                    </div>
                    <div class="col-md-6 order-1 order-md-2">
                        <div class="useful-link">
                          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'Footer',
    props: ["FooterStyle"],
    data () {
        return {
            socials: [
                {
                icon: 'fa fa-facebook',
                url: 'https://www.facebook.com/careforwild/?ref=hl',
                target: '_blank'
                },
                {
                icon: "fa fa-youtube",
                url: 'https://www.youtube.com/channel/UCa8im4i_52eiC3TyYRQe7pg',
                target: '_blank'
                },
                {
                icon: "fa fa-instagram",
                url: 'https://www.instagram.com/careforwild/',
                target: '_blank'
                }
            ]
        }
    }
}
</script>

<style lang='scss'>
    @import '../assets/scss/variables.scss';
    @import '../assets/scss/components/footer.scss';
</style>
